// For environment details see: https://confluence.mtvi.com/display/TCP/Global+Entry+-+execution+environment+-+Level+5+-+PROD

export * from './environment.common';
export const production = true;
